// extracted by css-extract-rspack-plugin
export default {"reviewsContainer":"_9cf86c86","noTabs":"_9e9cfb2d","spinnerWrapper":"_af44e906","noTabsWrapper":"_9aaffefe","translationToggle":"_8caaa371"};